import { render, staticRenderFns } from "./SeminarStat.vue?vue&type=template&id=87c6fa72&scoped=true&"
import script from "./SeminarStat.vue?vue&type=script&lang=js&"
export * from "./SeminarStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c6fa72",
  null
  
)

export default component.exports